import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Modal } from 'components/Modal';
import { Button } from 'components/Button';

import { deleteArtwork as deleteArtworkAction } from 'modules/artwork/actions';

import { Store } from 'types';
import { useAction } from 'utils';

import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';

import styles from './styles.module.scss';

type Props = {
  companyId: number;
  onClose: () => void;
  onArtworkDeleteSuccess: () => void;
};

export const DeleteArtworkModal: React.FC<Props> = memo(function DeleteArtworkModal({
  companyId,
  onClose,
  onArtworkDeleteSuccess,
}) {
  const { deleting, data } = useSelector((store: Store) => store.artwork);
  const deleteArtwork = useAction(deleteArtworkAction.request);

  const handleArtworkDelete = useCallback(() => {
    deleteArtwork({ companyId, artworkId: data!.id }, () => {
      onArtworkDeleteSuccess();
    });
  }, [companyId, data, deleteArtwork, onArtworkDeleteSuccess]);

  return (
    <Modal containerClassName={styles.container} onClose={onClose}>
      <div className={styles.delete_icon_container}>
        <DeleteIcon />
      </div>
      <h1>Delete artwork</h1>
      <h3>Are you sure to delete “{data?.name}”?</h3>
      <div className={styles.footer}>
        <Button title="Cancel" className={styles.cancel_button} onClick={onClose} />
        <Button
          title="Delete"
          loading={deleting}
          className={styles.delete_button}
          onClick={handleArtworkDelete}
        />
      </div>
    </Modal>
  );
});
